
<script>
export default {
    props: ["slides"],
    mounted() {  
    },
    data() {
        return {
            greeting: 'Hello World!'
        }
    }
}
</script>

<template>
    <p>{{slides}}</p>
</template>